import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from './pages/home/index.vue';
import FilterPage from './pages/filter/index.vue';
import NotFoundPage from './pages/NotFoundPage.vue';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/filter',
      name: 'filter',
      component: FilterPage,
    },
    {
      path: '*',
      name: '404',
      component: NotFoundPage,
    },
  ],
});
